import { useLayoutEffect } from "react";

/**
 * "Voltar" do navegador que sai do app (spec 045, 3.7 e 3.10): quando o checkout ou o link de pagamento foi a PRIMEIRA
 * pagina aberta nesta aba (veio de um link, sem historia dentro do app), voltar sai pro destino da pagina em vez de
 * deixar a pessoa numa aba vazia ou no app de mensagem. O destino e o mesmo do botao Voltar: o back redirect do checkout
 * quando o administrador definiu um, ou o site da marca (`linkPlanos`, do config.json). Sem `if` de marca.
 *
 * Como: a entrada em que a pagina abriu ganha a marca do destino e, por cima dela, entra uma copia da mesma pagina. O
 * voltar do navegador cai na entrada marcada, e a pagina troca o endereco pelo destino (`location.replace`, sem empilhar).
 * Quem chegou aqui navegando pelo app (indice > 0 no historico do roteador) volta normalmente: nada e marcado. As
 * navegacoes de dentro (ir pra area depois de pagar, `?s=` da sessao) acontecem acima da marca e nao a tocam.
 *
 * Destino `undefined` (a pagina ainda nao sabe, ex.: a vitrine carregando): nada e marcado. Marcar o site da marca e
 * trocar depois deixaria a volta errada no meio. Se o destino muda depois de marcado (a vitrine voltou com outro), vale
 * o novo: a entrada marcada fica abaixo da atual e o historico nao deixa reescreve-la, entao a pagina aberta guarda o
 * destino atual e ele vence o gravado na marca. Sem a pagina montada, vale o gravado.
 */
const CHAVE = "mtcVoltarPara";
type Estado = { idx?: number; [CHAVE]?: string } | null;

/** O destino que a pagina aberta conhece agora. */
let destinoAtual: string | undefined;

let ouvindo = false;
function ouvir() {
  if (ouvindo) return;
  ouvindo = true;
  window.addEventListener("popstate", () => {
    const marcado = (window.history.state as Estado)?.[CHAVE];
    if (marcado) window.location.replace(destinoAtual ?? marcado);
  });
}

export function useVoltarProSite(destino: string | undefined) {
  // Antes da pintura: quando a pagina aparece, a marca ja esta no historico (um voltar logo de cara ja sai pro destino).
  useLayoutEffect(() => {
    if (!destino) return;
    ouvir();
    destinoAtual = destino;
    const estado = (window.history.state ?? {}) as NonNullable<Estado>;
    // So na primeira entrada da aba (o roteador numera a partir de 0). Recarregar em cima da copia nao empilha outra.
    if ((estado.idx ?? 0) === 0) {
      window.history.replaceState({ ...estado, [CHAVE]: destino }, "");
      const { [CHAVE]: _marca, ...resto } = estado;
      window.history.pushState({ ...resto, idx: 1, key: Math.random().toString(36).slice(2, 10) }, "", window.location.href);
    }
    return () => {
      if (destinoAtual === destino) destinoAtual = undefined;
    };
  }, [destino]);
}
